import React, { useState } from "react";
import "./VideosPage.css"; 
import VideoModal from "./VideoModal"; 

const VideosPage = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  // Video Data (Replace URLs with actual video sources)
  const videoSections = [
    {
        title: "Admin Demo",
        videos: [
            { id: 1, title: "Admin Dashboard Overview", url: "/videos/admin1.mp4", thumbnail:"/images/soon.png"  },
            { id: 2, title: "Scheduling Approvals", url: "/videos/admin2.mp4", thumbnail:"/images/soon.png"  },
            { id: 3, title: "Managing Staff", url: "/videos/admin2.mp4", thumbnail:"/images/soon.png"  },
            { id: 10, title: "Syncing Calendar", url: "/videos/practitioner5.mp4", thumbnail:"/images/soon.png" },
        ],
    },
    {
        title: "Patient Demo",
        videos: [
            { id: 4, title: "Scheduling an Appointment", url: "/videos/patient1.mp4", thumbnail:"/images/soon.png"  },
            { id: 5, title: "Rescheduling & Cancelling", url: "/videos/patient2.mp4", thumbnail:"/images/soon.png"  },
            { id: 6, title: "Intake Forms & Past Appointments", url: "/videos/patient2.mp4", thumbnail:"/images/soon.png"  },
        ],
    },
    {
        title: "Practitioner Demo",
        videos: [
            { id: 7, title: "Handling Appointments", url: "/videos/practitioner1.mp4", thumbnail:"/images/soon.png"  },
            { id: 8, title: "Patient Consultation View", url: "/videos/practitioner2.mp4", thumbnail:"/images/soon.png" },
            { id: 9, title: "Adding Notes to Patient Records", url: "/videos/practitioner3.mp4", thumbnail:"/images/soon.png"  },
        ],
    },
];


  return (
    <div className="videos-page">
      <header className="videos-header">
        <h1>📽️ Explore Our Video Demos</h1>
        <p>Get a hands-on experience of our <strong>clinic scheduling software</strong> through video tutorials.</p>
        <hr className="divider" />
      </header>
  
      <section className="main-video-container">
        <h2>Experience our PlusLife</h2>
        <div className="laptop-frame">
        <video controls controlsList="nodownload">
          <source src="./soon.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        </div>
        <p className="video-description">This tour guides you through <strong>seamless features</strong> in our software.</p>
      </section>
      <hr className="divider" />

        {/* Sectioned Video Clips */}
        <div className="video-sections">
            {videoSections.map((section, index) => (
                <React.Fragment key={index}>
                    <div className="video-section">
                        <h3 className="section-title">{section.title}</h3>
                        <div className="video-thumbnails">
                            {section.videos.map((video) => (
                                <div
                                    key={video.id}
                                    className="video-card"
                                    onClick={() => setSelectedVideo(video)}
                                >
                                    <div className="video-thumbnail">
                                        <img src={video.thumbnail} alt={video.title} className="thumbnail-img" />
                                        <span className="play-icon">▶</span>
                                    </div>
                                    <p className="video-title">{video.title}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Add Divider Between Sections, But Not After the Last One */}
                    {index !== videoSections.length - 1 && <hr className="divider" />}
                </React.Fragment>
            ))}
        </div>

      {/* Video Modal - Appears on Click */}
      {selectedVideo && (
        <VideoModal video={selectedVideo} onClose={() => setSelectedVideo(null)} />
      )}
    </div>
  );
};

export default VideosPage;
